export default "__VITE_ASSET__CD_KFMlH__"